'use client';

import { I18nextProvider } from 'react-i18next';
import { type i18n } from 'i18next';

interface Props {
    children: React.ReactNode;
    locale: string | undefined;
    i18n: i18n;
}

export function I18nProvider({ children, locale, i18n }: Props) {
    if (i18n.resolvedLanguage !== locale) {
        void i18n.changeLanguage(locale);
    }
    return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
